import React from "react";
import { useAuth } from "../../contexts/AuthContext";
import AuthShell from "./AuthShell";
import { Clock, MessageCircle, LogOut, Lock, AlertCircle } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";

export default function PendingApproval() {
  const { signOut } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const { blocked, expired } = location.state || {};

  const getContent = () => {
    if (blocked) {
      return {
        title: "Acesso Suspenso",
        subtitle: "Sua conta foi bloqueada por um administrador.",
        icon: <Lock className="w-8 h-8 text-red-500" />,
        bg: "bg-red-500/10 border-red-500/20",
        msg: "Por favor, entre em contato com o suporte para entender o motivo e reativar seu acesso."
      };
    }
    if (expired) {
      return {
        title: "Assinatura Vencida",
        subtitle: "Seu período de acesso expirou.",
        icon: <AlertCircle className="w-8 h-8 text-amber-500" />,
        bg: "bg-amber-500/10 border-amber-500/20",
        msg: "Para continuar utilizando a plataforma, realize o pagamento da sua mensalidade."
      };
    }
    return {
      title: "Acesso em análise",
      subtitle: "Quase lá! Sua conta está sendo revisada.",
      icon: <Clock className="w-8 h-8 text-brand" />,
      bg: "bg-brand/5 border-brand/20",
      msg: "Para garantir a segurança, todos os novos perfis profissionais passam por uma análise manual."
    };
  };

  const content = getContent();

  return (
    <AuthShell title={content.title} subtitle={content.subtitle}>
      <div className="space-y-6">
        <div className={`ds-card p-6 flex flex-col items-center text-center ${content.bg}`}>
          <div className="w-16 h-16 rounded-full bg-white/50 flex items-center justify-center mb-4 shadow-sm">
            {content.icon}
          </div>
          <h3 className="text-lg font-bold tracking-tight" style={{fontFamily:"'Outfit',sans-serif"}}>
            {content.title}
          </h3>
          <p className="text-sm text-[hsl(var(--text-secondary))] mt-2">
            {content.msg}
          </p>
        </div>

        <div className="ds-card p-5 border-dashed border-[hsl(var(--border-divider))]">
          <div className="flex items-start gap-3">
            <div className="w-8 h-8 rounded-lg bg-[hsl(var(--bg-hover))] flex items-center justify-center shrink-0">
              <MessageCircle className="w-4 h-4 text-brand" />
            </div>
            <div>
              <div className="text-sm font-bold">Precisa de ajuda?</div>
              <p className="text-xs text-[hsl(var(--text-tertiary))] mt-0.5">
                Fale conosco agora para resolver sua situação e agilizar seu acesso.
              </p>
            </div>
          </div>
        </div>

        <button onClick={async () => { 
          try { await signOut(); } catch (e) { console.error(e); } 
          navigate("/"); 
        }} className="ds-btn-ghost w-full flex items-center justify-center gap-2 text-[hsl(var(--text-tertiary))]">
          <LogOut className="w-4 h-4" /> Sair da conta
        </button>
      </div>
    </AuthShell>
  );
}
